import { render, staticRenderFns } from "./Extra.vue?vue&type=template&id=0bca245b&scoped=true&"
import script from "./Extra.vue?vue&type=script&lang=js&"
export * from "./Extra.vue?vue&type=script&lang=js&"
import style0 from "./Extra.vue?vue&type=style&index=0&id=0bca245b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca245b",
  null
  
)

export default component.exports